import React from "react";
import { useTranslatedMessages } from "@/multiLanguage/i18n";
import { Box, Container, Typography, useMediaQuery, useTheme, Link } from "@mui/material";

import { CustomAppBar, BackButton } from "../components";
import { theme } from "@/theme";

export default function PrivacyPage() {
    const lang = useTranslatedMessages();
    const { breakpoints, palette } = useTheme();
    const isXs = useMediaQuery(breakpoints.only("xs"));

    return (
        <>
            <Box sx={{ padding: "10px", backgroundColor: theme.palette.secondary.main }}>
                <Container
                    fixed
                    sx={{ backgroundColor: theme.palette.primary.light, paddingBottom: "64px" }}
                >
                    <header>
                        <CustomAppBar
                            title={lang.pages.privacy.subName}
                            backButton={
                                <BackButton
                                    sx={{
                                        marginRight: "10px",
                                        color: theme.palette.secondary.dark,
                                    }}
                                />
                            }
                        />
                    </header>
                    <Box
                        className="scaleForm padding-large vertical-scrollable"
                        sx={{
                            ...(isXs && { height: "75%" }),
                            boxSizing: "border-box",
                            borderRadius: "20px",
                            paddingBottom: "32px",
                        }}
                    >
                        {/* Subtitle GDPR */}
                        <Typography
                            variant="subtitle1"
                            sx={{
                                textAlign: "center",
                                fontStyle: "italic",
                                marginBottom: 3,
                                color: palette.text.primary
                            }}
                        >
                            {lang.pages.privacy.gdprSubtitle}
                        </Typography>

                        {/* Chi Siamo */}
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: 700 }}
                            color={palette.secondary.dark}
                            align="left"
                            padding="10px 0 10px 0"
                            textTransform="uppercase"
                        >
                            {lang.pages.privacy.whoWeAre.title}
                        </Typography>
                        <Box sx={{
                            backgroundColor: palette.grey[50],
                            padding: 2,
                            borderRadius: 2,
                            marginBottom: 2,
                            borderLeft: `4px solid ${palette.secondary.dark}`
                        }}>
                            <Typography variant="body1" sx={{ marginBottom: 2 }}>
                                <strong>{lang.pages.privacy.whoWeAre.dataController}</strong> {lang.pages.privacy.whoWeAre.companyName}<br />
                                {lang.pages.privacy.whoWeAre.address}<br />
                                {lang.pages.privacy.whoWeAre.phone}<br />
                                {lang.pages.privacy.whoWeAre.email}<br />
                                {lang.pages.privacy.whoWeAre.website}
                            </Typography>
                            <Typography variant="body1">
                                <strong>{lang.pages.privacy.whoWeAre.dataProtectionOfficer}</strong> {lang.pages.privacy.whoWeAre.dpoCompany}<br />
                                {lang.pages.privacy.whoWeAre.dpoPhone}<br />
                                {lang.pages.privacy.whoWeAre.dpoEmail}
                            </Typography>
                        </Box>

                        {/* Cosa facciamo con i vostri dati */}
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: 700 }}
                            color={palette.secondary.dark}
                            align="left"
                            padding="10px 0 10px 0"
                            textTransform="uppercase"
                        >
                            {lang.pages.privacy.whatWeDoWithData.title}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.whatWeDoWithData.introduction}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.whatWeDoWithData.dataTypesDescription}
                        </Typography>

                        <Typography variant="h6" sx={{ fontWeight: 600, marginTop: 2, marginBottom: 1, color: palette.secondary.light }}>
                            {lang.pages.privacy.whatWeDoWithData.navigationData.title}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.whatWeDoWithData.navigationData.description}
                        </Typography>

                        <Typography variant="h6" sx={{ fontWeight: 600, marginTop: 2, marginBottom: 1, color: palette.secondary.light }}>
                            {lang.pages.privacy.whatWeDoWithData.voluntaryData.title}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.whatWeDoWithData.voluntaryData.description}
                        </Typography>

                        {/* Perché trattiamo i vostri dati */}
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: 700 }}
                            color={palette.secondary.dark}
                            align="left"
                            padding="10px 0 10px 0"
                            textTransform="uppercase"
                        >
                            {lang.pages.privacy.whyWeProcessData.title}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.whyWeProcessData.gdprCompliance}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.whyWeProcessData.noProfilingCookies}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.whyWeProcessData.technicalCookies}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.whyWeProcessData.technicalCookiesConsent}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.whyWeProcessData.profilingCookiesConsent}
                        </Typography>

                        {/* Come trattiamo i vostri dati */}
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: 700 }}
                            color={palette.secondary.dark}
                            align="left"
                            padding="10px 0 10px 0"
                            textTransform="uppercase"
                        >
                            {lang.pages.privacy.howWeProcessData.title}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.howWeProcessData.processingMethods}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.howWeProcessData.dataCenter}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.howWeProcessData.noAutomatedDecision}
                        </Typography>

                        {/* Dove e a chi finiscono i vostri dati */}
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: 700 }}
                            color={palette.secondary.dark}
                            align="left"
                            padding="10px 0 10px 0"
                            textTransform="uppercase"
                        >
                            {lang.pages.privacy.whereDataGoes.title}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.whereDataGoes.internalAnalysis}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.whereDataGoes.noThirdCountryTransfer}
                        </Typography>

                        {/* Quanto tempo conserviamo i vostri dati */}
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: 700 }}
                            color={palette.secondary.dark}
                            align="left"
                            padding="10px 0 10px 0"
                            textTransform="uppercase"
                        >
                            {lang.pages.privacy.dataRetention.title}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.dataRetention.retentionPeriod}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.dataRetention.cookieDuration}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 1 }}>
                            {lang.pages.privacy.dataRetention.cookieTypes}
                        </Typography>
                        <Box component="ul" sx={{ marginLeft: 3, marginBottom: 2 }}>
                            <Typography component="li" variant="body1" sx={{ marginBottom: 1 }}>
                                <strong>{lang.pages.privacy.dataRetention.sessionCookies.title}</strong> {lang.pages.privacy.dataRetention.sessionCookies.description}
                            </Typography>
                            <Typography component="li" variant="body1">
                                <strong>{lang.pages.privacy.dataRetention.persistentCookies.title}</strong> {lang.pages.privacy.dataRetention.persistentCookies.description}
                            </Typography>
                        </Box>

                        {/* Da chi riceviamo i vostri dati */}
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: 700 }}
                            color={palette.secondary.dark}
                            align="left"
                            padding="10px 0 10px 0"
                            textTransform="uppercase"
                        >
                            {lang.pages.privacy.dataSource.title}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.dataSource.directCollection}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.dataSource.publicEntities}
                        </Typography>

                        {/* Quali sono i vostri diritti */}
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: 700 }}
                            color={palette.secondary.dark}
                            align="left"
                            padding="10px 0 10px 0"
                            textTransform="uppercase"
                        >
                            {lang.pages.privacy.yourRights.title}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.yourRights.rightsDescription}
                        </Typography>

                        {/* Come potete esercitare i vostri diritti */}
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: 700 }}
                            color={palette.secondary.dark}
                            align="left"
                            padding="10px 0 10px 0"
                            textTransform="uppercase"
                        >
                            {lang.pages.privacy.exerciseRights.title}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.exerciseRights.contactDpo}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.exerciseRights.dpoResponse}
                        </Typography>

                        {/* Aggiornamenti */}
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: 700 }}
                            color={palette.secondary.dark}
                            align="left"
                            padding="10px 0 10px 0"
                            textTransform="uppercase"
                        >
                            {lang.pages.privacy.updates.title}
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 3 }}>
                            {lang.pages.privacy.updates.updatePolicy}
                        </Typography>

                        {/* Politica dei Cookie */}
                        <Box sx={{
                            backgroundColor: "#fff3e0",
                            padding: 3,
                            borderRadius: 2,
                            marginTop: 4,
                            border: "2px solid #ff9800"
                        }}>
                            <Typography
                                variant="h4"
                                sx={{ fontWeight: 700 }}
                                color="#ff6f00"
                                align="center"
                                padding="0 0 20px 0"
                                textTransform="uppercase"
                            >
                                {lang.pages.privacy.cookiePolicy.title}
                            </Typography>

                            <Typography variant="body1" sx={{ marginBottom: 2 }}>
                                {lang.pages.privacy.cookiePolicy.introduction}
                            </Typography>

                            <Typography variant="h6" sx={{ fontWeight: 600, marginTop: 3, marginBottom: 1, color: "#ff6f00" }}>
                                {lang.pages.privacy.cookiePolicy.presentOnSite}
                            </Typography>

                            <Typography variant="h6" sx={{ fontWeight: 600, marginTop: 2, marginBottom: 1 }}>
                                {lang.pages.privacy.cookiePolicy.technicalCookies.title}
                            </Typography>
                            <Typography variant="body1" sx={{ marginBottom: 2 }}>
                                {lang.pages.privacy.cookiePolicy.technicalCookies.description}
                            </Typography>

                            <Typography variant="body1" sx={{ marginBottom: 1 }}>
                                {lang.pages.privacy.cookiePolicy.technicalCookies.subdivisions}
                            </Typography>
                            <Box component="ul" sx={{ marginLeft: 3, marginBottom: 2 }}>
                                <Typography component="li" variant="body1" sx={{ marginBottom: 1 }}>
                                    <strong>{lang.pages.privacy.cookiePolicy.technicalCookies.navigationCookies.title}</strong> {lang.pages.privacy.cookiePolicy.technicalCookies.navigationCookies.description}
                                </Typography>
                                <Typography component="li" variant="body1" sx={{ marginBottom: 1 }}>
                                    <strong>{lang.pages.privacy.cookiePolicy.technicalCookies.analyticsCookies.title}</strong> {lang.pages.privacy.cookiePolicy.technicalCookies.analyticsCookies.description}
                                </Typography>
                                <Typography component="li" variant="body1">
                                    <strong>{lang.pages.privacy.cookiePolicy.technicalCookies.functionalCookies.title}</strong> {lang.pages.privacy.cookiePolicy.technicalCookies.functionalCookies.description}
                                </Typography>
                            </Box>

                            <Typography variant="h6" sx={{ fontWeight: 600, marginTop: 2, marginBottom: 1, color: "#ff6f00" }}>
                                {lang.pages.privacy.cookiePolicy.notPresentOnSite}
                            </Typography>

                            <Typography variant="h6" sx={{ fontWeight: 600, marginTop: 2, marginBottom: 1 }}>
                                {lang.pages.privacy.cookiePolicy.profilingCookies.title}
                            </Typography>
                            <Typography variant="body1" sx={{ marginBottom: 2 }}>
                                {lang.pages.privacy.cookiePolicy.profilingCookies.description}
                            </Typography>

                            <Typography variant="h6" sx={{ fontWeight: 600, marginTop: 2, marginBottom: 1 }}>
                                {lang.pages.privacy.cookiePolicy.thirdPartyCookies.title}
                            </Typography>
                            <Typography variant="body1" sx={{ marginBottom: 2 }}>
                                {lang.pages.privacy.cookiePolicy.thirdPartyCookies.description}
                            </Typography>
                        </Box>

                        {/* Gestione dei Cookie */}
                        <Typography
                            variant="h5"
                            sx={{ fontWeight: 700 }}
                            color={palette.secondary.dark}
                            align="left"
                            padding="20px 0 10px 0"
                            textTransform="uppercase"
                        >
                            {lang.pages.privacy.cookieManagement.title}
                        </Typography>

                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.cookieManagement.browserSettings}
                        </Typography>

                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.cookieManagement.defaultSettings}
                        </Typography>

                        <Typography variant="body1" sx={{ marginBottom: 1 }}>
                            {lang.pages.privacy.cookieManagement.thirdPartyOptOut}
                        </Typography>
                        <Box component="ul" sx={{ marginLeft: 3, marginBottom: 2 }}>
                            <Typography component="li" variant="body1">
                                <Link href="https://www.youronlinechoices.com/it/" target="_blank" rel="noopener noreferrer">
                                    {lang.pages.privacy.cookieManagement.optOutLinks.yourOnlineChoices}
                                </Link>
                            </Typography>
                            <Typography component="li" variant="body1">
                                <Link href="https://optout.networkadvertising.org/?c=1" target="_blank" rel="noopener noreferrer">
                                    {lang.pages.privacy.cookieManagement.optOutLinks.naiOptOut}
                                </Link>
                            </Typography>
                            <Typography component="li" variant="body1">
                                <Link href="https://www.garanteprivacy.it/temi/cookie" target="_blank" rel="noopener noreferrer">
                                    {lang.pages.privacy.cookieManagement.optOutLinks.garantePrivacy}
                                </Link>
                            </Typography>
                        </Box>
                        <Typography variant="body1" sx={{ marginBottom: 1 }}>
                            {lang.pages.privacy.cookieManagement.browserSpecificInstructions}
                        </Typography>
                        <Box sx={{
                            padding: 2,
                            borderRadius: 1,
                            marginBottom: 2
                        }}>
                            <Typography variant="body1" sx={{ marginBottom: 1 }}>
                                <strong>Microsoft Edge:</strong>{' '}
                                <Link href="https://www.microsoft.com/it-It/privacy/privacystatement#maincookiessimilartechnologiesmodule" target="_blank" rel="noopener noreferrer">
                                    {lang.pages.privacy.cookieManagement.browserLinks.microsoftEdge}
                                </Link>
                            </Typography>
                            <Typography variant="body1" sx={{ marginBottom: 1 }}>
                                <strong>Google Chrome:</strong>{' '}
                                <Link href={lang.pages.privacy.cookieManagement.browserLinks.googleChrome} target="_blank" rel="noopener noreferrer">
                                    {lang.pages.privacy.cookieManagement.browserLinks.googleChrome}
                                </Link>
                            </Typography>
                            <Typography variant="body1" sx={{ marginBottom: 1 }}>
                                <strong>Mozilla Firefox:</strong>{' '}
                                <Link href={lang.pages.privacy.cookieManagement.browserLinks.mozillaFirefox} target="_blank" rel="noopener noreferrer">
                                    {lang.pages.privacy.cookieManagement.browserLinks.mozillaFirefox}
                                </Link>
                            </Typography>
                            <Typography variant="body1">
                                <strong>Apple Safari:</strong>{' '}
                                <Link href={lang.pages.privacy.cookieManagement.browserLinks.appleSafari} target="_blank" rel="noopener noreferrer">
                                    {lang.pages.privacy.cookieManagement.browserLinks.appleSafari}
                                </Link>
                            </Typography>
                        </Box>

                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {lang.pages.privacy.cookieManagement.disablingConsequences}
                        </Typography>

                        <Box sx={{
                            textAlign: "center",
                            fontStyle: "italic",
                            color: palette.text.secondary,
                            marginTop: 4,
                            padding: 3,
                            backgroundColor: "#f0f7ff",
                            borderRadius: 2,
                            border: `1px solid ${palette.primary.light}`
                        }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                {lang.pages.privacy.farewell.message}
                            </Typography>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </>
    );
}